import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalGeneral extends Component {
  constructor(props) {
    super(props)

  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle}>{this.props.modalTitle}</ModalHeader>
          <ModalBody>
            {this.props.modalBody}
          </ModalBody>
          {
            !this.props.btnCancelDisabled &&
            <ModalFooter>
              <Button color="dark" onClick={this.props.toggle}>Cerrar</Button>
            </ModalFooter>
          }
        </Modal>
      </div>
    );
  }
}

export default ModalGeneral;